import classNames from 'classnames';
import { ComponentProps } from 'react';
import { FavouriteIcon } from '@tymbe/ui-icons';

type EmojiOwnProps = {
  emoji?: string | null,
  className?: string
};
type EmojiProps = EmojiOwnProps & Omit<ComponentProps<'div'>, keyof EmojiOwnProps>;

const Emoji = ({ emoji, className = '', ...rest }: EmojiProps) => (
  <div
    className={classNames('flex justify-center items-center rounded-[4px]', className)}
    {...rest}
  >
    {emoji ?? <FavouriteIcon name="placeholder" className="p-1.5" />}
  </div>
);

export default Emoji;
